<template>
  <div>
    <intro-hero />
    <section id="recentPosts" class="hero is-small">
      <div class="hero-body">
        <div class="container">
          <ul>
            <li v-for="(post, key) in posts" :key="key" class="recentExcerpts">

              <nuxt-link :to="'/posts/'+post.title_slug+'/'">
                <h2>
                  {{ post.title }}
                </h2>
              </nuxt-link>

              <div class="postTags">
                <span class="posted">POSTED {{ post.datePublished | toDate }}</span>
                <nuxt-link v-for="tag in post.tags" :key="tag" :to="'/category/'+tag">#{{ tag }}&nbsp;&nbsp;</nuxt-link>
              </div>

              <div class="postContent" v-html="post.excerpt" />
              <nuxt-link :to="'/posts/'+post.title_slug" class="readMore">
                Read more
              </nuxt-link>
              <br><br><br>
              <hr v-if="key !== posts.length - 1">
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import IntroHero from '~/components/blog/IntroHero.vue'

export default {
  components: {
    IntroHero
  },
  head () {
    return {
      title: 'The Blog'
    }
  },
  computed: {
    ...mapState([
      'posts'
    ])
  }
}
</script>

<style scoped>
  span.posted{
    display: inline-block;
    margin-right: 1em;
  }
  #recentPosts h2{
    margin-bottom: 0em;
  }
  .postTags{
    margin-bottom: 1em;
  }
</style>
